import { custom, success } from "./utilities";
import { employeeConstants, globalConstants } from "../../constants";
import { employeeService } from "../../services/employee.services";
import { ToastifyService } from "../../services/toastify.services";
import { flattenedData } from "../../shared/utility";

const gridData = {
  column: "",
  type: "",
  search: null,
  filters: [],
};

export const getAllEmployee = (gridState) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .getAll(gridState)
      .then((response) => {
        dispatch(success(response.data, employeeConstants.GET_EMPLOYEES));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getEmployeeById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .getById(id)
      .then((response) => {
        dispatch(success(response.data, employeeConstants.GET_EMPLOYEE_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteEmployeeById = (id, projectId = 0) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .deleteById(id)
      .then((response) => {
        dispatch(getAllEmployee(gridData));
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const createEmployee = (data, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .create(data)
      .then((response) => {
        dispatch(getAllEmployee(gridData));
        onHide();
        ToastifyService.showSuccess("Done Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateEmployee = (data, id, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .update(data, id)
      .then((response) => {
        dispatch(getAllEmployee(gridData));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteEmployeePermanentById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .deleteEmployeePermanentById(id)
      .then((response) => {
        dispatch(getAllEmployee(gridData));
        ToastifyService.showSuccess("Deleted Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getDashboardStats = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .dashboardStats()
      .then((response) => {
        dispatch(success(response.data, employeeConstants.GET_DASHBOARD_STATS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllEmployeeAttendanceById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .getAllEmployeeAttendanceById(id)
      .then((response) => {
        dispatch(
          success(
            flattenedData([response.data]),
            employeeConstants.GET_EMPLOYEES_Attendance_By_Id
          )
        );
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const employeeCheckIn = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .employeeCheckIn()
      .then((response) => {
        dispatch(getAllEmployeeAttendanceById(id));
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const employeeCheckOut = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .employeeCheckOut()
      .then((response) => {
        dispatch(getAllEmployeeAttendanceById(id));
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllEmployeesAttendance = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .getAllAttendances()
      .then((response) => {
        dispatch(
          success(
            flattenedData(response.data),
            employeeConstants.GET_ALL_EMPLOYEES_ATTENDANCE
          )
        );
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateSession = (data, id, onHide, onHideSessionModal) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .updateSession(data)
      .then((response) => {
        dispatch(getAllEmployeeAttendanceById(id));
        onHide();
        onHideSessionModal();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const addSession = (data, id, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .addSession(data)
      .then((response) => {
        dispatch(getAllEmployeeAttendanceById(id));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const duplicateAttendance = (data, employeeUserId) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    employeeService
      .duplicateAttendance(data)
      .then((response) => {
        dispatch(getAllEmployeeAttendanceById(employeeUserId));
        ToastifyService.showSuccess(response?.message || "Attendance duplicated successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const employeeActions = {
  getAllEmployee,
  getEmployeeById,
  deleteEmployeeById,
  createEmployee,
  updateEmployee,
  deleteEmployeePermanentById,
  getDashboardStats,
  getAllEmployeeAttendanceById,
  employeeCheckIn,
  employeeCheckOut,
  getAllEmployeesAttendance,
  updateSession,
  addSession,
  duplicateAttendance
};
